import * as PrefabManager from '../PrefabManager';
import * as AudioManager from '../../utils/AudioManager';

import {
    game
} from "../../Game";

import {Humanoid} from '../humanoids/Humanoid'
import { bladeCut } from './bladeCut';

const { getPointer } = Box2D;
const manifold = new Box2D.b2WorldManifold();

export class SliceObject extends PrefabManager.weaponPrefab {
    constructor(target) {
        super(target);
    }
    init() {
        this.sliceForce = 50;
        super.init();
        this.sliceBody = this.lookupObject['sliceBody'];
        this.hits = [];
        AudioManager.preloadSFX('sword-slash');
    }
    update(){
        super.update();
        if(!this.hits.length) return;
        const hits = this.hits;
        this.hits = [];
        hits.forEach(hit => bladeCut(this.sliceBody, hit.body, hit));
    }
    initContactListener() {
        super.initContactListener();
        const self = this;
        this.contactListener.PostSolve = function (contact, impulse) {
            const bodies = [contact.GetFixtureA().GetBody(), contact.GetFixtureB().GetBody()];

            const sliceBody = (bodies[0] == self.sliceBody) ? bodies[0] : bodies[1];
            const otherBody = (bodies[0] == self.sliceBody) ? bodies[1] : bodies[0];

            if(sliceBody != self.sliceBody || !otherBody.isFlesh) return;

            const count = contact.GetManifold().get_pointCount();
            let force = 0;
            for (let j = 0; j < count; j++) force += impulse.get_normalImpulses(j);
            if(force > self.sliceForce){
                if(count > 0 && !self.hits.some(hit => getPointer(hit.body) === getPointer(otherBody))){
                    contact.GetWorldManifold(manifold);
                    let x = 0;
                    let y = 0;
                    for (let j = 0; j < count; j++) {
                        const point = manifold.get_points(j);
                        x += point.get_x() / count;
                        y += point.get_y() / count;
                    }
                    // The manifold's normal points from fixture A to fixture B.
                    const towardsPart = contact.GetFixtureA().GetBody() === self.sliceBody ? 1 : -1;
                    const normal = manifold.get_normal();
                    self.hits.push({body: otherBody, x, y, nx: normal.get_x() * towardsPart, ny: normal.get_y() * towardsPart});
                }

                const refName = otherBody?.mySprite?.data?.refName;
                let damage = 30;
                if(refName === Humanoid.BODY_PARTS.HEAD || refName === Humanoid.BODY_PARTS.BODY){
                    damage = 1000;
                }
                const characterClass = game.editor.retrieveSubClassFromBody(otherBody);
                characterClass?.dealDamage?.(damage);
            }

		}
    }
}
